




























import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Gap } from '@xlearn/common';
import { Dictionary } from 'lodash';
import i18n from '@/plugins/i18n';
import * as Api from "@/app/question/components/api";
import { FillInAnswers } from './fill-in-interfaces'
import { FillInCorrectAnswer } from './fill-in-question-component.vue'

@Component
export default class FillInQuestionSolutionComponent extends Vue
  implements Api.QuestionSolutionProps2<FillInAnswers, FillInCorrectAnswer>  {
  @Prop({
    required: true,
  })
  public userAnswer: FillInAnswers;

  @Prop({
    required: true,
  })
  public correctAnswer: FillInCorrectAnswer;

  private correct(gap: Gap): boolean {
    if (!this.userAnswer[gap.id]) {
      return false;
    }

    return gap.goodAnswerId === this.userAnswer[gap.id];
  }

  private answeredAnswer(gap: Gap): string {
    const noAnswer: string = this.t('question.fill-in.solution.missing_answer').toString();
    if (!this.userAnswer[gap.id]) {
      return noAnswer;
    }

    const answerId: string = this.userAnswer[gap.id];
    const answer = gap.answers.find((a) => a.id === answerId);
    if (!answer) {
      return noAnswer;
    }

    return answer.text;
  }

  private showCorrectAnswer(gap: Gap): string {
    const answer = gap.answers.find((a) => a.id === gap.goodAnswerId);
    if (!answer) {
      throw new Error(`No good answer found in gap with gapId: ${gap.id}`);
    }

    return answer.text;
  }

  private t(key: string, params: any = {}) {
    return i18n.t(key, params);
  }

}
